/* ALTMERCH — animated brand backgrounds (sections/altmerch-collection.liquid).
   canvas.am-bg__rain       1337 LEETSYNDICATE: matrix code rain.
   canvas.am-bg__intercept  Black Hat Collective: scrolling intercepted-data feed
                            with redaction bars and glitch tears.
   Canvases stay transparent, so the layer's opacity setting controls intensity.
   Animation pauses off-screen; visitors who prefer reduced motion get one
   static frame. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pick = (list) => list[(Math.random() * list.length) | 0];
  const rand = (min, max) => min + Math.random() * (max - min);

  function run(canvas, effect) {
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const view = { ctx, canvas, width: 0, height: 0 };
    let running = false;
    let visible = true;
    let last = 0;

    function resize() {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      view.width = canvas.clientWidth;
      view.height = canvas.clientHeight;
      if (!view.width || !view.height) return;
      canvas.width = Math.round(view.width * dpr);
      canvas.height = Math.round(view.height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      effect.setup(view);
    }

    function step() {
      // A page opened in a background tab can report zero size at first.
      if (!view.width || !view.height) {
        resize();
        if (!view.width || !view.height) return;
      }
      effect.step(view);
    }

    function loop(now) {
      if (!running) return;
      if (now - last >= effect.frameMs) {
        last = now;
        step();
      }
      requestAnimationFrame(loop);
    }

    function start() {
      if (running || reduceMotion.matches || !visible) return;
      running = true;
      requestAnimationFrame(loop);
    }

    function stop() {
      running = false;
    }

    function paintStatic() {
      ctx.clearRect(0, 0, view.width, view.height);
      for (let i = 0; i < effect.staticSteps; i++) step();
    }

    resize();
    if (reduceMotion.matches) paintStatic();
    else start();

    new ResizeObserver(() => {
      resize();
      if (reduceMotion.matches) paintStatic();
    }).observe(canvas);

    new IntersectionObserver((entries) => {
      visible = entries.some((e) => e.isIntersecting);
      if (visible) start();
      else stop();
    }).observe(canvas);

    reduceMotion.addEventListener('change', () => {
      if (reduceMotion.matches) {
        stop();
        paintStatic();
      } else {
        start();
      }
    });
  }

  /* ---- 1337: matrix code rain ---- */

  const RAIN_GLYPHS = 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワン0123456789010110011337$#%&<>/{}[]=+*'.split('');

  function rain() {
    const FONT = 16;
    let drops = [];
    let speeds = [];
    return {
      frameMs: 50,
      staticSteps: 90,
      setup(v) {
        const cols = Math.ceil(v.width / FONT);
        drops = Array.from({ length: cols }, () => Math.random() * -(v.height / FONT));
        speeds = Array.from({ length: cols }, () => rand(0.45, 1.15));
      },
      step(v) {
        const { ctx } = v;
        ctx.globalCompositeOperation = 'destination-out';
        ctx.fillStyle = 'rgba(0, 0, 0, 0.09)';
        ctx.fillRect(0, 0, v.width, v.height);
        ctx.globalCompositeOperation = 'source-over';

        ctx.font = `${FONT}px ui-monospace, "Space Mono", monospace`;
        ctx.textBaseline = 'top';
        const color = getComputedStyle(v.canvas).color || '#39FF7A';

        for (let i = 0; i < drops.length; i++) {
          const y = drops[i] * FONT;
          if (y > -FONT) {
            ctx.fillStyle = Math.random() < 0.06 ? '#E6FFEC' : color;
            ctx.fillText(pick(RAIN_GLYPHS), i * FONT, y);
          }
          drops[i] += speeds[i];
          if (y > v.height && Math.random() > 0.97) drops[i] = rand(-12, 0);
        }
      },
    };
  }

  /* ---- Black Hat: intercepted-data feed ---- */

  const HEX = '0123456789abcdef';
  const TAGS = ['INTERCEPT', 'EXFIL', 'HANDSHAKE', 'DECRYPT', 'TRACE', 'SNIFF', 'PAYLOAD', 'KEYLOG', 'CRACKED'];
  const STATES = ['OK', 'DENIED', 'REDACTED', 'PWNED', 'LOGGED', 'OPEN', 'TIMEOUT', '0xDEAD'];

  const hexByte = () => pick(HEX) + pick(HEX);
  const ip = () => `${(rand(10, 223)) | 0}.${(rand(0, 255)) | 0}.${(rand(0, 255)) | 0}.${(rand(1, 254)) | 0}`;

  function feedLine() {
    let text;
    if (Math.random() < 0.55) {
      const addr = Array.from({ length: 8 }, () => pick(HEX)).join('');
      const bytes = Array.from({ length: 16 }, hexByte).join(' ');
      const ascii = Array.from({ length: 16 }, () => pick('.....abcdefghklmnoprstuvwxyz#@$%&')).join('');
      text = `${addr}  ${bytes}  |${ascii}|`;
    } else {
      const t = new Date(Date.now() - rand(0, 9e7));
      const stamp = t.toISOString().slice(11, 23);
      text = `[${stamp}] ${pick(TAGS).padEnd(9)} ${ip()} -> ${ip()}:${(rand(20, 65535)) | 0}  len=${(rand(40, 9000)) | 0}  ${pick(STATES)}`;
    }
    const redactions = [];
    if (Math.random() < 0.4) {
      const count = Math.random() < 0.3 ? 2 : 1;
      for (let i = 0; i < count; i++) {
        const start = (rand(0, text.length * 0.75)) | 0;
        redactions.push({ start, len: (rand(6, 22)) | 0, life: (rand(40, 220)) | 0 });
      }
    }
    return { text, redactions, hot: 0 };
  }

  function intercept() {
    const FONT = 13;
    const LINE = 20;
    let lines = [];
    let offset = 0;
    let charW = 8;
    let tearFrames = 0;
    return {
      frameMs: 40,
      staticSteps: 1,
      setup(v) {
        v.ctx.font = `${FONT}px ui-monospace, "Space Mono", monospace`;
        charW = v.ctx.measureText('0').width || 8;
        const rows = Math.ceil(v.height / LINE) + 2;
        const cols = Math.ceil(v.width / (charW * 72)) || 1;
        lines = Array.from({ length: rows }, () => Array.from({ length: cols }, feedLine));
        offset = 0;
      },
      step(v) {
        const { ctx } = v;
        const color = getComputedStyle(v.canvas).color || '#FF3B4E';
        const colW = charW * 72;

        offset += 0.7;
        if (offset >= LINE) {
          offset -= LINE;
          lines.shift();
          lines.push(Array.from({ length: lines[0].length }, feedLine));
        }
        if (Math.random() < 0.02) pick(pick(lines)).hot = 14;

        ctx.clearRect(0, 0, v.width, v.height);
        ctx.font = `${FONT}px ui-monospace, "Space Mono", monospace`;
        ctx.textBaseline = 'top';

        lines.forEach((row, r) => {
          const y = r * LINE - offset;
          row.forEach((line, c) => {
            const x = 16 + c * colW;
            ctx.globalAlpha = line.hot > 0 ? 1 : 0.55;
            ctx.fillStyle = line.hot > 0 ? '#FFD4D8' : color;
            ctx.fillText(line.text, x, y);
            if (line.hot > 0) line.hot--;

            ctx.globalAlpha = 1;
            line.redactions.forEach((red) => {
              if (red.life-- > 0) {
                ctx.fillStyle = '#050202';
                ctx.fillRect(x + red.start * charW - 2, y - 2, red.len * charW + 4, FONT + 4);
              }
            });
          });
        });

        // Occasional glitch tear: shift a few horizontal slices sideways.
        if (tearFrames > 0 || Math.random() < 0.012) {
          tearFrames = tearFrames > 0 ? tearFrames - 1 : 4;
          const dpr = v.canvas.width / v.width;
          for (let i = 0; i < 3; i++) {
            const sy = rand(0, v.height - 30);
            const sh = rand(6, 28);
            const dx = rand(-24, 24);
            ctx.drawImage(v.canvas, 0, sy * dpr, v.canvas.width, sh * dpr, dx, sy, v.width, sh);
          }
        }
        ctx.globalAlpha = 1;
      },
    };
  }

  document.querySelectorAll('canvas.am-bg__rain').forEach((c) => run(c, rain()));
  document.querySelectorAll('canvas.am-bg__intercept').forEach((c) => run(c, intercept()));
})();
